/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - DEFAULT AVATAR PACK: STYLES --------------- ++++++++++ */
export default theme => ({
  defaultavatarpack: {
    '& .singleselectdropdown': {
      width: pxToEm(300)
    }
  }
});
